import { Component, computed, inject} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { AvatarModule } from 'primeng/avatar';
import { ToolbarModule } from 'primeng/toolbar';
import { LayoutService } from '../services/layout.service';
import { UserInnerComponent } from "./layout/user-inner/user-inner.component";
import { RouterLink } from "@angular/router";
import { AppSidebar } from "./layout/sidebar/sidebar.component";


@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [ButtonModule, StyleClassModule,
    AvatarModule, ToolbarModule, UserInnerComponent, AppSidebar],
  template:`
      <nav class="bg-white border-gray-400 border-b-2 py-2.5">        
        <div class="flex items-center justify-between px-4 mx-auto">
          <!-- Left: Heading -->
          <div class="flex items-center gap-4">
            <app-sidebar/>
            <div class="flex flex-row">
              <img src="favicon.png" alt="Covariance Logo" width="40" height="40"/>
              <span class="self-center text-xl font-semibold">Covariance</span>
            </div>
          </div> 
          <!-- Right: Avatar -->
           <div class="relative">
              <div
                class="!h-[40px] !w-[40px] cursor-pointer"
                pStyleClass="@next"
                enterFromClass="hidden"
                enterActiveClass="animate-scalein"
                leaveToClass="hidden"
                leaveActiveClass="animate-fadeout"
                [hideOnOutsideClick]="true"
              >
                <img
                  height="50"
                  width="50"
                  class="!h-[40px] !w-[40px] !object-cover rounded-xl"
                  src="./assets/images/user_avatar.png"
                />
              </div>
              <app-user-inner />
            </div>       
        </div>
      </nav>
      `
  })



export class AppTopbar {
  layoutService: LayoutService = inject(LayoutService);
  
    
  isDarkMode = computed(() => this.layoutService.appState().darkMode);
  

  

  toggleDarkMode() {
    this.layoutService.appState.update((state) => ({
      ...state,
      darkMode: !state.darkMode,
    }));
  }   
  
}
